import { Meta } from "@/@types/paginated";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Load } from "components/load";
import PageError from "components/page-error";
import { format } from "date-fns";
import { useGetLateStoresQuery } from "@/services/store/store";
import { handeOrderBy } from "@/utils/pagination";
import { useFilterState } from "../ducks/filter/hooks/filterState";
import { useColumns } from "./columns";
import { DateRangeHeader } from "./components/date-range-header";
import SelectFilters from "./components/select-filters";
import Table from "./components/table";

export const LateReconciliation: React.FC = () => {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const columns = useColumns();

  const { responsible, regional_id, dateRange, order: orderObj } = filters;
  const { from, to } = dateRange ?? {};

  const orderBy = handeOrderBy(orderObj);

  const getResponsibleFilter = () => {
    if (!responsible || (Array.isArray(responsible) && responsible.length === 0)) return undefined;
    return responsible;
  };

  const getRegionalFilter = () => {
    if (!regional_id || (Array.isArray(regional_id) && regional_id.length === 0)) return undefined;
    return regional_id;
  };

  const {
    data: res,
    isLoading,
    isFetching,
    error,
  } = useGetLateStoresQuery({
    orderBy: JSON.stringify(orderBy),
    ...(getResponsibleFilter() !== undefined && { responsible: getResponsibleFilter() }),
    ...(getRegionalFilter() !== undefined && { regional_id: getRegionalFilter() }),
    ...(from !== undefined && {
      transactionStartDate:
        format(new Date(from), "yyyy-MM-dd") + "T00:00:00.000Z",
    }),
    ...(to !== undefined && {
      transactionEndDate: format(new Date(to), "yyyy-MM-dd") + "T23:59:59.999Z",
    }),
    perPage: filters?.meta?.perPage || 10,
    page: filters?.meta?.page || 1,
  });

  const { data, meta } = res ?? { data: [], meta: {} };

  if (error) {
    return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
  }

  if (isLoading) {
    return <Load />;
  }

  return (
    <PageLayout>
      <div className="flex-1 w-full flex justify-between items-center">
        <PageTitle
          title="Conciliações Atrasadas"
          description="Acompanhe as conciliações pendentes por loja"
        />
        <DateRangeHeader />
      </div>
      <ContentContainer>
        <div className="mb-4">
          <SelectFilters />
        </div>
        <Table
          data={data}
          meta={meta as Meta}
          columns={columns}
          isFetching={isFetching}
        />
      </ContentContainer>
    </PageLayout>
  );
};
